/**
 * Classifies a failed withdrawal request into what the investor should see.
 *
 * The backend distinguishes (since PR #1414):
 *  - 409: the investor's earlier withdrawal is already in the payout pipeline — the retry is
 *    a double-submit after an unconfirmed success. This is a CONFIRMATION, not an error.
 *  - 503: transient lock contention — safe and sensible to retry in a few seconds.
 *  - no HTTP response (network cut, proxy timeout, axios timeout): the request MAY have
 *    committed server-side; the investor must check their account before retrying.
 *
 * Returns {variant, message, messageKey, keepForm}:
 *  - message: server-provided text to show verbatim (null if none)
 *  - messageKey: i18n key to translate client-side (used when there is no server text)
 *  - keepForm: whether resubmitting could possibly help
 */
export function classifyWithdrawError(error)
{
  const response = error && error.response
  const serverMessage = (response && response.data && response.data.errorMessage) || null

  if (!response)
  {
    return {variant: 'warning', message: null, messageKey: 'views.withdraw.unconfirmedMsg', keepForm: false}
  }

  if (response.status === 409)
  {
    return {variant: 'info', message: serverMessage, messageKey: serverMessage ? null : 'views.withdraw.alreadyPendingMsg', keepForm: false}
  }

  if (response.status === 503)
  {
    return {variant: 'warning', message: serverMessage, messageKey: serverMessage ? null : 'views.withdraw.busyMsg', keepForm: true}
  }

  return {variant: 'warning', message: serverMessage, messageKey: serverMessage ? null : 'views.withdraw.genericErrorMsg', keepForm: true}
}
